import React from "react"
import { useLocation } from "react-router-dom"

export const useLocationArray = () => {
    const location = useLocation()
    const res = location.pathname.split("/").filter(el => !!el)
    return res
}